export default __webpack_public_path__ + "static/Coffee day-1250b7f06d0e624fb88348f0cea17386.jpg";